import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import dayjs from "dayjs";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const LOGO_WHITE = "https://customer-assets-jai6qajn.emergentagent.net/job_type-race-4/artifacts/a9pwlfiw_white_text_racing.png";

export default function Flyer() {
  const { id } = useParams();
  const { user } = useAuth();
  const [c, setC] = useState(null);
  const [err, setErr] = useState(false);
  const [refCode, setRefCode] = useState("");

  useEffect(() => {
    api.get(`/contests/${id}`).then((r) => setC(r.data)).catch(() => setErr(true));
  }, [id]);

  // Bake the sharer's Racing Team code into their flyer so scans credit their team.
  useEffect(() => {
    if (!user) { setRefCode(""); return; }
    if (user.affiliate_code) { setRefCode(user.affiliate_code); return; }
    api.get("/affiliate/me").then((r) => setRefCode(r.data?.affiliate_code || "")).catch(() => {});
  }, [user]);

  if (err) return <div className="text-race-sub p-10 text-center">Contest not found.</div>;
  if (!c) return <div className="text-race-sub p-10 text-center">Loading flyer…</div>;

  const target = `${window.location.origin}/e/${c.id}${refCode ? `?ref=${refCode}` : ""}`;
  const prize = c.prize_pool_credits > 0 ? `$${(c.prize_pool_credits / 100).toFixed(0)}` : "PRIZE";

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-8">
      <div className="relative w-full max-w-sm overflow-hidden border border-[#2A2A2E]"
        style={{ background: "#0B0B0C" }} data-testid="flyer-card">
        <div className="p-8 text-center" style={{ color: "#F5F4F0" }}>
          <img src={LOGO_WHITE} alt="Text Racing" className="h-8 w-auto mx-auto mb-6" />

          <div className="font-mono text-[11px] uppercase tracking-[0.25em]" style={{ color: "#9A9A96" }}>
            {c.race_type} · {dayjs(c.start_time).format("ddd MMM D")}
          </div>
          <div className="font-heading text-7xl leading-[0.85] tracking-tight mt-3">
            {c.prize_pool_credits > 0 ? prize : "RACE"}
          </div>
          {c.prize_pool_credits > 0 && (
            <div className="font-heading text-3xl tracking-tight leading-none">PRIZE</div>
          )}

          <div className="mt-6 inline-block px-4 py-1" style={{ background: "#F5F4F0", color: "#0B0B0C" }}>
            <span className="font-heading text-2xl tracking-tight">{c.name.replace("www.", "").replace(".com", "")}</span>
          </div>

          <p className="mt-8 font-semibold">Scan to enter the calendar and register.</p>
          <p className="mt-1 text-sm font-mono" style={{ color: "#9A9A96" }}>
            Starts {dayjs(c.start_time).format("ddd, MMM D · h:mm A")} {new Intl.DateTimeFormat("en-US", { timeZoneName: "short" }).formatToParts(new Date()).find((p) => p.type === "timeZoneName")?.value || ""}
          </p>

          <div className="mt-6 flex justify-center">
            <div className="p-3" style={{ background: "#F5F4F0" }}>
              <QRCodeSVG value={target} size={150} fgColor="#0B0B0C" bgColor="#F5F4F0" data-testid="flyer-qr" />
            </div>
          </div>

          <div className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em]" style={{ color: "#5C5B56" }}>
            IBRA Sanctioned · BR Protocol
          </div>
          {refCode && (
            <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em]" style={{ color: "#7CF03A" }} data-testid="flyer-team-credit">
              Racing Team · {refCode}
            </div>
          )}
        </div>

        <Link to={`/e/${c.id}`} data-testid="flyer-open"
          className="block text-center py-3 text-sm font-semibold uppercase tracking-wide transition-colors"
          style={{ background: "#17171A", color: "#F5F4F0" }}>
          Open Race
        </Link>
      </div>
    </div>
  );
}
